import axiosInstance from './../axiosInstance';
import moment from 'moment';

/**
 * @name getNotifications
 * @desc Get notifications for a partner.
 * @param {string} partnerID
 * @param {string} userID
 */
export const getNotifications = (partnerID, userID) => {
    return axiosInstance.get(`partners/${partnerID}/users/${userID}/notifications`);
  };

 /**
  * @name markNotificationAsRead
  * @desc Set notification marked as read by user
  * @param {string} partnersUsersNotificationsID
  */
export const markNotificationAsRead = (partnersUsersNotificationsID) => {
  return axiosInstance.post(`partnersUsersNotifications/${partnersUsersNotificationsID}`, {
    markedAsRead: true, 
    timeRead: moment().format()
  });
};